import i18n from '@/i18n.js'

const roles = {
  neuro: 'neuro_admin',
  hospital: 'hospital_admin',
  doctor: 'doctor',
  readonly: 'readonly'
}

const status = {
  plan: 1,
  active: 2,
  done: 3,
  doneNotCorrectly: 7,
  missed: 4,
  closed: 5,
  canceled: 5,
  closedWrong: 6
}

const userStatus = {
  unregistered: 5,
  active: 1,
  blocked: 2
}

const deviceStatus = {
  work: 1,
  unknown: 2,
  broken: 3,
  lost: 4
}

const eventTypes = {
  stopTraining: 'TE',
  changeHR: 'HR',
  changeSR: 'SR',
  changeBF: 'BF',
  cardioEvent: 'CE',
  break: 'BR',
  reconnected: 'RC',
  startTraining: 'TB',
  devicesCharge: 'CHRG',
  changeCoordinate: 'GEO'
}

const courseTypes = {
  rehab: 1,
  telemetry: 2,
  single: 3
}

const serverSettings = {
  ecgStorage: {
    1: i18n.t('src/pages/settings.fileSystem'),
    2: i18n.t('src/pages/settings.storageS3')
  }
}

const HEART_RATE = {
  min: 40,
  max: 200,
  defaultStart: 70,
  defaultEnd: 100
}

const DATE_FORMAT = {
  ru: 'DD.MM.YYYY',
  ruShort: 'DD.MM.YY',
  ruFull: 'DD.MM.YYYY HH:mm:ss',
  server: 'YYYY-MM-DD',
  serverFull: 'YYYY-MM-DD HH:mm:ss',
  timeHM: 'HH:mm',
  timeHMS: 'HH:mm:ss',
  timeMS: 'mm:ss'
}

const FIND_BY_PERSON = {
  patient: 'p',
  doctor: 'd'
}

const unitDuration = {
  minutes: 1,
  hours: 2,
  days: 3
}

const TRAINING_TYPE = {
  base: 0,
  sixmwt: 1
}

const TRAINING_DEFAULT_COMMENTS = {
  base: i18n.t('src/components/training/traininggenerator.baseTask'),
  sixmwt: i18n.t('src/components/training/traininggenerator.sixmwtTask')
}

const legendType = {
  holdHR: 0,
  averageHR: 1,
  distance: 2,
  saturation: 3,
  pressure: 4,
  glucose: 5
}

const measurementType = {
  all: 1,
  standart: 2,
  mwt6: 3,
  free: 4
}

const timePeriods = {
  allTime: 1,
  oneDay: 2,
  oneWeek: 3,
  oneMonth: 4,
  threeMonths: 5
}

const messageTypes = {
  standart: 1,
  auto: 2,
  saturation: 3,
  pressure: 4,
  glucose: 5,
  diary: 6
}

export {
  roles,
  status,
  userStatus,
  deviceStatus,
  eventTypes,
  serverSettings,
  courseTypes,
  unitDuration,
  DATE_FORMAT,
  HEART_RATE,
  FIND_BY_PERSON,
  TRAINING_TYPE,
  TRAINING_DEFAULT_COMMENTS,
  measurementType,
  timePeriods,
  messageTypes,
  legendType
}
